import { render, staticRenderFns } from "./HeroDetails.vue?vue&type=template&id=70cc9f91&scoped=true&"
import script from "./HeroDetails.vue?vue&type=script&lang=js&"
export * from "./HeroDetails.vue?vue&type=script&lang=js&"
import style0 from "./HeroDetails.vue?vue&type=style&index=0&id=70cc9f91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc9f91",
  null
  
)

export default component.exports